/**
 * Created by karora on 19/03/17.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { LookupTable } from '../types/lookup-table-type';
import { SubMenuOption } from '../types/submenu-option';

@Component({
  selector: 'customertypes',
  template: `<sub-menu [options]="subMenu" [currentRoute]="currentRoute"></sub-menu>
<ul>
  <li *ngFor="let lookup of lookupValues">
    <span class="key">{{lookup.key}}</span>
    <span class="value">{{lookup.value}}</span>
  </li>
</ul>`,
  styles: [
    `:host ul { display: block; padding-inline-start: unset; }`,
    `li { display: block; color: #1e1e1e; background-color: #d0d0d0; margin: 0.2em 0; vertical-align: middle;}`,
    `li:hover {color: #1e1e1e; background-color: #a1d6ca;}`,
    `span {margin: 0.1em 0.2em; padding: 0.1em 0.3em; border: 2px solid transparent; border-radius: 6px;
            line-height: 200%; font-family: Poppins, Arial, "Helvetica Neue", Helvetica, sans-serif;}`,
    `span.key { display: inline-block; width: 8em; }`,
    `span.value { display: inline-block; width: 24em; }`,
  ],
})

export class CustomerTypesComponent implements OnInit {
  currentRoute = '/lookups/customer_types';
  tableName = 'unknown';
  lookupValues = <LookupTable[]>[];
  errorMessage: string;
  subMenu = <SubMenuOption[]>([
    {route: `/lookups/customer_types`, title: 'Customer Types'},
    {route: `/lookups/issue_source`, title: 'Issue Sources'},
    {route: `/lookups/issue_status`, title: 'Issue Statuses'},
    {route: `/lookups/issue_action_type`, title: 'Issue Actions'},
    {route: `/lookups/installation_states`, title: 'Installation States'},
    {route: `/lookups/stock_statuses`, title: 'Stock Statuses'},
  ]);

  constructor(
    private hubService: HubService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    AppComponent.SetTitle('Lookup Table');
    this.activatedRoute.params.pipe(
      switchMap((params: Params) => this.getRows(params['lookup']))
    ).subscribe(
      (lookup_values: LookupTable[]) => this.gotRows(lookup_values),
      error => this.errorMessage = <any>error,
    );
  }

  getRows(table: string): Observable<Object[]> {
    this.tableName = table;
    this.currentRoute = this.router.url;
    // this.observer = new Subject<Object[]>();
    console.log(`Requesting rows for '${table}' lookups`);
    return this.hubService.getLookupTable(table);
    // return this.observer;
  }

  gotRows(rows: Object[]): void {
    this.lookupValues = [] as LookupTable[];

    // convert the incoming table into a stable key/value naming convention
    let idField = 'id';
    let descField = 'description';
    for (let i = 0; i < rows.length; i++) {
      if (i === 0) {
        for (let key of Object.keys(rows[i])) {
          if (idField === 'id') {
            if (key.slice(-3) === '_id' || key === 'uid') {
              idField = key;
            }
          }
          if (descField === 'description') {
            if (key.slice(-5) === '_text' || key.slice(-5) === '_desc' || key.slice(-12) === '_description') {
              descField = key;
            }
          }
        }
      }
      this.lookupValues.push(
        <LookupTable>{
          key: rows[i][idField],
          value: rows[i][descField],
        }
      );
    }

    console.log(`Got rows from lookup: ${JSON.stringify(rows)}`);
    console.log(`Converted to: ${JSON.stringify(this.lookupValues)}`);
  }
}
